/**
 * 判断当前环境是否为AInvest客户端
 * @returns {boolean} 如果是AInvest客户端返回 true，否则返回 false
 * @example
 * ```ts
 * isInAInvestApp(); // => true (在AInvest客户端内)
 * isInAInvestApp(); // => false (在浏览器中)
 * ```
 */
export function isInAInvestApp(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }
  const ua = navigator.userAgent.toLowerCase();
  return /\blhbd\b/i.test(ua);
}
